import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ToolDetailComponent } from '../tool-detail/tool-detail.component';
import { ToolTraceComponent } from '../tool-trace/tool-trace.component';
import { ToolSearchState } from '../../../store/toolSearch/tool-search-state';
import { Observable, Subscription } from 'rxjs';
import { Select } from '@ngxs/store';
import { ToolService } from '../../../service/tool.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-tool-table',
  templateUrl: './tool-table.component.html',
  styleUrls: ['./tool-table.component.less']
})
export class ToolTableComponent implements OnInit {

  @Input() code: any; // code 0 备件只能查看，不能选择 code 1 备件可以查看 也可以被选中
  confirmModal?: NzModalRef;
  // 查询条件
  @Select(ToolSearchState) toolSearchState$: Observable<any>;
  searchSubscription: Subscription = null;
  conditions: any = null;
  listOfSelection = [
    {
      text: '全选',
      onSelect: () => {
        this.checkAll(true);
      }
    }
  ];
  // 分页查询条件
  pageIndex: number;
  pageSize: number;
  loading = true;
  total = 0;
  checkShow = true;
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  mapOfCheckedId: { [key: string]: boolean } = {};
  listOfData = [];
  listOfDisplayData = [];
  listOfBatchDeleteData = [];
  setOfCheckedId = new Set<number>();
  toolStatus = new Map();

  toolsImportModal?: NzModalRef;
  toolsDataToImport;

  constructor(private modal: NzModalService, private toolService: ToolService, public message: NzMessageService,) { }

  ngOnInit(): void {
    this.pageIndex = 1;
    this.pageSize = 10;
    this.getToolStatus();
    // 刷新查询结果
    this.queryData();
  }

  getToolStatus() {
    this.toolService.getToolStatusList().subscribe((response: any) => {
      if (response.code === 200) {
        response.data.forEach(element => {
          this.toolStatus.set(element.dictValue, element.dictLabel);
        });
      }
    });
  }
  currentPageDataChange($event: []): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(): void {
    this.isAllDisplayDataChecked = this.listOfDisplayData.every(item => this.mapOfCheckedId[item.tno]);
    this.isIndeterminate = this.listOfDisplayData.some(item => this.mapOfCheckedId[item.tno]) && !this.isAllDisplayDataChecked;
    this.listOfBatchDeleteData = this.listOfData.filter(item => this.mapOfCheckedId[item.tno]);
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(item => (this.mapOfCheckedId[item.tno] = value));
    this.refreshStatus();
  }

  sendNewToolRequest() {
    const toolModal = this.modal.create({
      nzTitle: '新建工具',
      nzContent: ToolDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 650,
      nzFooter: null,
      nzComponentParams: {
        operateToolFlag: '0',
      },
    });
    toolModal.afterClose.subscribe(() => this.queryData());
  }
  sendBatchDeleteRequest(): void {
    this.confirmModal = this.modal.confirm({
      nzTitle: '您确定要批量删除这些记录吗？',
      nzContent: '当点击确定时，选中的记录将会从列表中被删除！',
      nzOkDanger: true,
      nzOnOk: () => {
        this.loading = true;
        if (this.listOfBatchDeleteData.length === 0) {
          this.message.info('请选择要删除的工具！');
          this.loading = false;
          return;
        }
        const request = {
          data: this.listOfBatchDeleteData
        };

        this.toolService.deleteToolBatch(request).subscribe((response: any) => {
          if (response.code === 200) {
            this.queryData();
            this.isAllDisplayDataChecked = false;
            this.isIndeterminate = false;
            this.loading = false;
            this.message.success('批量删除成功！');
          } else {
            this.loading = false;
            this.message.error('批量删除失败！');
          }
        }, err => {
          this.loading = false;
          this.message.error('批量删除失败: ' + err.msg);
        });
      }
    });
  }

  showDeleteConfirm(tool: any): void {
    this.confirmModal = this.modal.confirm({
      nzTitle: '您确定要删除该条记录吗？',
      nzContent: '当点击确定时，该条记录将会从列表中被删除！',
      nzOkDanger: true,
      nzOnOk: async () => {
        const result = await this.toolService.deleteTool(tool.tno);
        if (result === 0) {
          this.message.create('error', '工具删除失败!');
        } else {
          this.message.create('success', '工具删除成功!');
        }
        this.queryData();
      }
    });
  }

  showModifyDetail(tool: any) {
    const toolModal = this.modal.create({
      nzTitle: '修改工具',
      nzContent: ToolDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 650,
      nzFooter: null,
      nzComponentParams: {
        currentTool: tool,
        operateToolFlag: '1',
      }
    });
    toolModal.afterClose.subscribe(() => this.queryData());
  }

  showModifyRecords(tool: any) {
    this.modal.create({
      nzTitle: '工具变动记录',
      nzOkText: null,
      nzCancelText: '返回',
      nzBodyStyle: { padding: '10px' },
      nzContent: ToolTraceComponent,
      nzComponentParams: { currentTool: tool },
    });
  }

  async queryData() {
    // alert('正在查询数据！！！');
    this.searchSubscription = this.toolSearchState$.subscribe(async (conditions: any) => {
      this.conditions = conditions;
      const result = await this.toolService.getAllToolsListByCondition(this.conditions, this.pageIndex, this.pageSize);
      this.loading = false;
      if (result === null) {
        return;
      } else {
        this.listOfData = result.list;
        this.listOfData.forEach(element => {
          element.statusStr = this.toolStatus.get(element.status);
        });
        this.total = result.total;
      }
    });
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnDestroy(): void {
    // 取消订阅
    if (this.searchSubscription != null) {
      this.searchSubscription.unsubscribe();
      this.searchSubscription = null;
    }
  }

  createToolsImportModal(tplTitle: TemplateRef<{}>, tplContent: TemplateRef<{}>, tplFooter: TemplateRef<{}>) {

    this.toolsImportModal = this.modal.create({
      nzTitle: tplTitle,
      nzContent: tplContent,
      nzFooter: tplFooter,
      nzMaskClosable: false,
      nzClosable: false,
      nzComponentParams: {
        value: 'Template Context'
      },
      nzOnOk: () => console.log('Click ok')
    });

  }

  cancelToolsImport() {
    this.toolsDataToImport = [];
    this.toolsImportModal.destroy();
  }

  submitToolsImport() {

    if(this.toolsDataToImport.length===0) {
      return;
    }

    this.toolService.batchAddTools(this.toolsDataToImport).subscribe((result: any) => {
      if (result.code === 200) {
        this.message.create('success', '创建工具成功!');
        this.toolsImportModal.destroy();
      } else {
        this.message.create('error', '创建工具失败!');
      }
    });

  }

  uploadToolsFile($event) {

    const target: DataTransfer = ($event.target) as DataTransfer;
    if (target.files.length !== 0) {
      if (target.files.length !== 1) { throw new Error('Cannot use multiple files'); }
    }

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      //const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', cellDates: true, dateNF: 'yyyy/MM/dd' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      let toolsDataExcel = XLSX.utils.sheet_to_json(ws, { raw: false });

      this.toolsDataToImport = [];

      for (let i = 0; i < toolsDataExcel.length; i++) {

        let itemTmp = toolsDataExcel[i];

        let tname = itemTmp["名称"];
        let b = itemTmp["类型"];
        let boughtTime = itemTmp["购买时间"];
        let amount = itemTmp["数量"];
        let toolUser = itemTmp["责任人"];

        if (tname === undefined || b === undefined || boughtTime === undefined || amount === undefined || toolUser === undefined) {
          this.message.create('warning', '导入excel数据有误，请仔细检查文件!');
          this.toolsImportModal.destroy();
          return;
        }

        let ttNo = b.substring(0, b.indexOf("-"));

        this.toolsDataToImport.push({
          tname: tname,
          ttNo: ttNo,
          toolUser: toolUser,
          boughtTime: boughtTime,
          amount: amount,
          phone: itemTmp["电话"],
          spec: itemTmp["规格"],
          unit: itemTmp["单位"],
          status: 1,
          toolDesc: itemTmp["描述"],
          //createBy: this.userInfo.userId,
        });
      }

    };
    reader.readAsBinaryString(target.files[0]);

  }

}
